import { Button } from "@material-ui/core"
import { useIsDesktop } from "common/MediaQueries"
import Image from "next/image"
import { Dispatch, SetStateAction, useState } from "react"
import PopUp from "reusable/popups/PopUp"
import styled from "styled-components"

const StyledCopyText = styled.p`
  font-family: OENaPro;
  font-style: normal;
  font-weight: 300;
  font-size: 16px;
  line-height: 150%;
  text-align: center;
  color: ${(p) => p.theme.colors.black};
  margin: 0;

  ${(p) => p.theme.breakpoints.up("md")} {
    font-size: 18px;
    width: 75%;
  }
`

const StyledTextContainer = styled.div`
  margin-top: 8px;
  margin-bottom: 20px;
  display: flex;
  justify-content: center;
`

const StyledCopyContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`

const StyledButton = styled(Button)`
  background: black;
  color: white;
  border-radius: 3px;

  &:hover {
    color: white;
    box-shadow: none;
    background-color: #3a3d46;
  }
`

type Props = {
  setCopyPopupOpen: Dispatch<SetStateAction<boolean>>
  customClose: () => void
  copyPopupOpen: boolean
  copyText: string
  link: string
  title?: string
  buttonText?: string
}

function CopyPopup({
  setCopyPopupOpen,
  customClose,
  copyPopupOpen,
  copyText,
  link,
  title,
  buttonText,
}: Props) {
  const isDesktop = useIsDesktop()

  const [success, setSuccess] = useState<boolean>(false)

  return (
    <PopUp
      header={title || "שיתוף ההצעה"}
      setOpen={setCopyPopupOpen}
      customClose={() => {
        customClose()
        setSuccess(false)
      }}
      open={copyPopupOpen}
      maxWidth="sm"
    >
      <StyledCopyContainer>
        <StyledTextContainer>
          <StyledCopyText>{copyText}</StyledCopyText>
        </StyledTextContainer>

        {success ? "הקישור הועתק בהצלחה" : null}

        <StyledButton
          size="large"
          onClick={() => {
            if (isDesktop && navigator?.clipboard) {
              navigator?.clipboard.writeText(`${link}`)
              setSuccess(true)
              return
            }
            // Not needed anymore cause we added share on outside for mobile
            // if (!isDesktop && navigator?.share) {
            //   navigator?.share({ text: copyText, url: link })
            //   setSuccess(true)
            // }
          }}
          startIcon={<Image src="/copyIcon.svg" width={12} height={13.3} />}
        >
          {buttonText}
        </StyledButton>
      </StyledCopyContainer>
    </PopUp>
  )
}

export default CopyPopup
